import { Component, OnInit } from '@angular/core';
import { DirectEditService } from '@app/modules/direct/services/direct-edit.service';
import { DirectService, SiteStatistics } from '@app/modules/direct/services/direct.service';

type PeriodValue = 'week' | 'week-last' | 'month' | 'month-last' | 'year' | 'year-last';

interface Period {
  label: string;
  value: PeriodValue;
}

@Component({
  selector: 'sbnb-direct-edit-insights',
  templateUrl: './direct-edit-insights.component.html',
})
export class DirectEditInsightsComponent implements OnInit {
  statistics?: SiteStatistics;
  selectedPeriod: PeriodValue = 'month';
  periods: Period[] = [
    { label: 'This week', value: 'week' },
    { label: 'Last week', value: 'week-last' },
    { label: 'This month', value: 'month' },
    { label: 'Last month', value: 'month-last' },
    { label: 'This year', value: 'year' },
    { label: 'Last year', value: 'year-last' },
  ];
  loadingStatistics = false;

  constructor(
    public readonly directEditService: DirectEditService,
    private readonly direct: DirectService
  ) {}

  ngOnInit(): void {
    this.getSiteStatistics(this.selectedPeriod);
  }

  getSiteStatistics(period: PeriodValue) {
    this.loadingStatistics = true;
    this.direct.getSiteStatistics(this.directEditService.site.id, period).subscribe((statistics) => {
      this.statistics = statistics;
      this.loadingStatistics = false;
    });
  }
}
